<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}

.lang-width {
  width: 450px !important;
}

.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.notice-main-title-div {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.query-flex-btns-div {
  display: flex;
  justify-content: flex-end;
}

.eye {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    right: 20%;
  }
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">报名用户订单列表</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="
          () => {
            showMultiQuerys = !showMultiQuerys;
          }
        ">
          高级筛选
        </button>
        <button class="common-bg-button" @click="toExportList()">
          导 出
        </button>
      </div>
      <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input clearable v-model="queryInfo.keyWord" size="small" placeholder="请输入订单编号/用户手机/用户姓名/支付流水号" />
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">订单创建时间</p>
              <div class="flex-r">
                <el-date-picker v-model="queryInfo.createFromTime" type="datetime" size="small"
                  prefix-icon="el-icon-date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间" class="flex-1" />
                <span class="time-query-line" style="line-height: 32px">-</span>
                <el-date-picker v-model="queryInfo.createToTime" type="datetime" size="small" prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间" class="flex-1" />
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="query-flex-btns-div margin-bottom-16">
          <button class="common-bg-button" @click="getListData(pagination, true)">
            搜 索
          </button>
          <button class="common-bg-button" @click="resetQuery()">
            重 置
          </button>
        </div>
      </div>

      <!-- 表格 -->
      <div class="list-table">
        <el-table :data="tableData" style="width: 100%" border stripe>
          <el-table-column type="selection" width="40" align="center" />
          <el-table-column prop="name" label="用户姓名" width="240" align="center" fixed="left" />
          <el-table-column prop="mobile" label="" width="200" align="center" fixed="left" :key="Math.random()">
            <div slot="header" style="
                display: flex;
                align-items: center;
                justify-content: center;
              ">
              <span style="margin-right: 8px">用户手机号</span>
              <img style="width: 20px; height: 20px" src="../../../assets/app-card-style/眼睛_隐藏.png" alt=""
                v-if="!isFlag" @click="flagChange()" />
              <img style="width: 20px; height: 20px" src="../../../assets/app-card-style/眼睛_显示.png" alt="" v-if="isFlag"
                @click="flagChange()" />
            </div>
            <template slot-scope="scope">
              <span v-if="isFlag">{{ scope.row.mobile }}</span>
              <span v-else>{{
                scope.row.mobile
                  ? scope.row.mobile.replace(
                    scope.row.mobile.substring(2, 9),
                    "*******"
                  )
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="province" label="省" width="240" align="center" />
          <el-table-column prop="city" label="市" width="240" align="center" />
          <el-table-column prop="area" label="区" width="240" align="center" />
          <el-table-column prop="address" label="详细地址" width="200" align="center">
            <template slot-scope="scope">
              <el-popover placement="top-start" width="200" trigger="hover" :disabled="scope.row.address.length <= 10">
                <div>{{ scope.row.address }}</div>
                <span slot="reference" v-if="scope.row.address.length <= 10">{{ scope.row.address }}</span>
                <span slot="reference" v-if="scope.row.address.length > 10">{{ scope.row.address.substr(0, 10) + "..."
                  }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="activityOrderNo" label="活动订单编号" width="240" align="center" />
          <el-table-column prop="purchaseName" label="购买名称" width="240" align="center" />
          <el-table-column prop="pileAssetCode" label="资产编号" width="240" align="center" />
          <el-table-column prop="pileCode" label="imei" width="240" align="center" />
          <el-table-column prop="activityStatus" label="活动状态" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.activityStatus == 'COMMIT'">已报名</span>
              <span v-if="scope.row.activityStatus == 'TO_SIGN'"> 待签约</span>
              <span v-if="scope.row.activityStatus == 'IN_SIGN'"> 已签约</span>
              <span v-if="scope.row.activityStatus == 'TO_INSTALL'">待安装</span>
              <span v-if="scope.row.activityStatus == 'TO_ACTIVATION'">待激活</span>
              <span v-if="scope.row.activityStatus == 'IN_USE'">使用中</span>
              <span v-if="scope.row.activityStatus == 'TO_COMPLIANCE'">待守约</span>
              <span v-if="scope.row.activityStatus == 'IN_OVERDUE'">已逾期</span>
              <span v-if="scope.row.activityStatus == 'IN_DEFAULTED'">已违约</span>
              <span v-if="scope.row.activityStatus == 'IN_CANCELING'">解约申请中</span>
              <span v-if="scope.row.activityStatus == 'IN_CANCELLED_BUYOUT'">已解约(买断)</span>
              <span v-if="scope.row.activityStatus == 'IN_CANCELLED_REFUNDED'">
                已解约(退款)</span>
              <span v-if="scope.row.activityStatus == 'IN_CANCELLED_DEFAULTED'">已解约(违约)</span>
              <span v-if="scope.row.activityStatus == 'IN_CLOSE'">已退出</span>
              <span v-if="scope.row.activityStatus == 'TO_RESET_SIGN'">待激活签约</span>
              <span v-if="scope.row.activityStatus == 'IN_EXPIRED'">已到期</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdWhen" label="订单创建时间" width="240" align="center" />
          <el-table-column prop="installStatus" label="安装状态" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.installStatus == 'INVESTIGATION_INSTALL_INIT'">未勘察未安装</span>
              <span v-if="
                scope.row.installStatus == 'INVESTIGATION_INSTALL_FINISHED'
              ">已勘察已安装</span>
              <span v-if="
                scope.row.installStatus ==
                'INVESTIGATION_FINISHED_NOT_INSTALL'
              ">已勘察不安装</span>
              <span v-if="
                scope.row.installStatus == 'INVESTIGATION_INIT_NOT_INSTALL'
              ">未勘察不安装</span>
            </template>
          </el-table-column>
          <el-table-column prop="installFailReason" label="不安装原因" width="240" align="center" />
          <el-table-column prop="pileInstallCompletedTime" label="安装完成时间" width="240" align="center" />
          <el-table-column prop="isBound" label="是否已绑定" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isBound == 'Y'">已绑定</span>
              <span v-if="scope.row.isBound == 'N'">未绑定</span>
            </template>
          </el-table-column>
          <el-table-column prop="bindChannel" label="绑定渠道" width="240" align="center" />
          <el-table-column prop="bindSource" label="绑定来源" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.bindSource == '1'">公域绑定</span>
              <span v-if="scope.row.bindSource == '2'">小程序绑定</span>
              <span v-if="scope.row.bindSource == '3'">APP协议同步绑定推送成功</span>
              <span v-if="scope.row.bindSource == '4'">APP绑定推送成功</span>
              <span v-if="scope.row.bindSource == '5'">一键登录绑定推送成功</span>
            </template>
          </el-table-column>
          <el-table-column prop="bindTime" label="首次绑定时间" width="240" align="center" />
          <el-table-column prop="serviceFee" label="服务费单价" width="240" align="center" />
          <el-table-column prop="agreementExpireTime" label="协议到期时间" width="240" align="center" />
          <el-table-column prop="usedTime" label="已使用时间" width="240" align="center" />
          <el-table-column prop="privateOrderCount" label="累计私桩充电订单数" width="240" align="center" />
          <el-table-column prop="chargeDuration" label="累计充电时长" width="240" align="center" />
          <el-table-column prop="chargeDegree" label="累计充电度数" width="240" align="center" />
          <el-table-column prop="lastPrivateChargeTime" label="最后一次私桩充电时间" width="240" align="center" />
          <el-table-column prop="sharedOrderCount" label="共享充电订单数" width="240" align="center" />
          <el-table-column prop="sharedDuration" label="累计充电时长（共享）" width="240" align="center" />
          <el-table-column prop="sharedDegree" label="累计充电度数（共享）" width="240" align="center" />
          <el-table-column prop="lastShareStartTime" label="最后一次开启私桩共享时间" width="240" align="center" />
          <el-table-column prop="lastShareChargeTime" label="最后一次私桩共享充电时间" width="240" align="center" />
          <el-table-column prop="receivableIncome" label="单桩累计应收收益" width="240" align="center" />
          <el-table-column prop="actualIncome" label="桩累计实收收益" width="240" align="center" />
          <el-table-column prop="isDefault" label="是否违约" width="240" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isDefault == 'Y'">已违约</span>
              <span v-if="scope.row.isDefault == 'N'">未违约</span>
            </template>
          </el-table-column>
          <el-table-column prop="defaultType" label="违约类型" width="240" align="center" />
          <el-table-column prop="suspendStartTime" label="停用开始时间" width="240" align="center" />
          <el-table-column prop="suspendEndTime" label="停用结束时间" width="240" align="center" />
          <el-table-column prop="paymentAmount" label="用户支付金额" width="240" align="center" />
          <el-table-column prop="actualAmount" label="实际到账金额" width="240" align="center" />
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData" />
      </div>
    </div>

    <!-- 退款编辑 -->
    <el-dialog title="退款编辑" width="520px" :visible.sync="showRtOrderDialog">
      <el-form :model="rtOrderFormInfo" ref="userRfForm" :rules="rtOrderFormRules">
        <el-form-item label="退款流水号" prop="transactionNo">
          <el-input clearable v-model="rtOrderFormInfo.transactionNo" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRtOrderForm('userRfForm')" size="small">提 交</el-button>
        <el-button @click="showRtOrderDialog = false" size="small">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      isFlag: false,
      tableData: [], // 表格数据
      pageConfig: pageConfig, // 页面配置
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      showMultiQuerys: false,
      orderStatusList: [],

      showRtOrderDialog: false,
      rtOrderFormInfo: {},
      rtOrderFormRules: {},
    };
  },
  methods: {
    flagChange() {
      this.isFlag = !this.isFlag;
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 1;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H
        .post(_, _.$A.activityOrder.registerUserOrderInfo, _.queryInfo)
        .then((res) => {
          _.tableData = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });
    },
    // 导出
    toExportList() {
      let _ = this;
      let urls = "";
      const host = window.location.hostname;
      if (host.includes("shzhida.com")) {
        urls = "http://ocharge.shzhida.com:6777";
      } else {
        urls = "http://192.168.8.174:7997";
      }
      // if (process.env.NODE_ENV == 'development') {
      //   urls = 'http://192.168.8.174:7997'
      // } else {
      //   urls = 'http://ocharge.shzhida.com:6777'
      // }
      _.$U.showLoading(_);
      _.$H
        .post(_, _.$A.activityOrder.registerUserOrderInfoExcel, _.queryInfo)
        .then((res) => {
          _.$U.saveExcelFile(res.data.data);
          var downUrl = urls + res.data.data.filePath;
          // var downUrl = 'http://ocharge.shzhida.com:6777'  + res.data.data.filePath;
          window.open(downUrl, "_blank");
          _.$U.hideLoading(_);
        });
    },
    // 重置
    resetQuery() {
      this.queryInfo = {
        keyWord: undefined, // 关键字
        createFromTime: undefined, // 订单创建时间
        createToTime: undefined, // 订单创建时间
      };
      this.getListData(this.pagination, true);
    },
  },
  mounted() {
    this.getListData(this.pagination, true);
  },
};
</script>
